import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

const bulletedListConfig = [
  { bulletText: 'We act in a fiduciary capacity in providing you advice for your account.' },
  { bulletText: (<>We provide ongoing monitoring of your account &#40;other than financial planning&#41;. This is in contrast to NMIS brokerage services, which does not provide ongoing account monitoring.</>) },
  { bulletText: (<>We act with full investment management discretion &#40;other than financial planning&#41;.</>) },
  { bulletText: (<>Advisory accounts have investment dollar amount minimums that range from &#36;25,000 to &#36;1,000,000 &#40;other than financial planning&#41; and we advise only on VAs issued by NM.</>) },
];

export default () => (
  <SectionContainer
    id='disclosure-brochures'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          nextElement='typography'>
          Investment Advisory Program Disclosure Brochures
        </Typography>
        <Typography nextElement='typography'>
          Download an investment advisory program or fee&#45;based planning disclosure brochure by clicking below:
        </Typography>
        <BulletedList
          bulletType='none' // filledCircle, checkmark, disc, none, orderedDecimal, orderedLowerAlpha, orderedLowerRoman, orderedUpperAlpha, orderedUpperRoman
          // themeType='lightTheme' // lightTheme (default), darkTheme, nmx-pcg
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id='disclosure-brochures-signature-portfolios-link'
                  variant='primaryDeemphasize'
                  isInternalPdf
                  linkUrl='/assets/pdf/brochures/signature-portfolios-disclosure.pdf'>
                  Northwestern Mutual Signature Portfolios Disclosure Brochure
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id='disclosure-brochures-signature-choice-link'
                  variant='primaryDeemphasize'
                  isInternalPdf
                  linkUrl='/assets/pdf/brochures/signature-choice-disclosure.pdf'>
                  Northwestern Mutual Signature Choice Disclosure Brochure
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id='disclosure-brochures-signature-annuities-link'
                  variant='primaryDeemphasize'
                  isInternalPdf
                  linkUrl='/assets/pdf/brochures/signature-annuities-disclosure.pdf'>
                  Northwestern Mutual Signature Annuities Disclosure Brochure
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id='disclosure-brochures-signature-managed-accounts-link'
                  variant='primaryDeemphasize'
                  isInternalPdf
                  linkUrl='/assets/pdf/brochures/signature-managed-accounts-disclosure.pdf'>
                  Northwestern Mutual Signature Managed Accounts Disclosure Brochure
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id='disclosure-brochures-private-client-services-link'
                  variant='primaryDeemphasize'
                  isInternalPdf
                  linkUrl='/assets/pdf/brochures/private-client-services-disclosure.pdf'>
                  Northwestern Mutual Private Client Services Disclosure Brochure
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id='disclosure-brochures-retirement-plan-services-link'
                  variant='primaryDeemphasize'
                  isInternalPdf
                  linkUrl='/assets/pdf/brochures/retirement-plan-services-disclosure.pdf'>
                  Northwestern Mutual Retirement Plan Services Disclosure Brochure
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id='disclosure-brochures-feebased-financial-planning-link'
                  variant='primaryDeemphasize'
                  isInternalPdf
                  linkUrl='/assets/pdf/brochures/feebased-financial-planning-disclosure.pdf'>
                  Northwestern Mutual Fee&#45;based Planning Disclosure Brochure
                </Link>
              ),
            },
          ]}
          // disableBottomPadding
        />
        <Typography nextElement='graphic'>
          We offer investment advisory programs and services to retail investors through our financial representatives who are qualified agents of Northwestern Mutual Wealth Management Company &#40;NMWMC&#41; and use &#34;Advisor&#34; in their title or otherwise disclose their status as an advisor of NMWMC. Through our investment advisory services:
        </Typography>
        <BulletedList bulletedListData={bulletedListConfig} />
      </Col>
    </Row>
  </SectionContainer>
);
